import { useEffect } from "react";
import { useSpaces } from "../api/hooks";
import { useActiveSpace } from "../api/space-context";

// Aplica a cor primária da org ativa sobrescrevendo as CSS vars --color-primary
// / -dark / -light. Os tons dark/light são derivados da cor da org (escurece p/
// hover de botão, clareia p/ texto no dark mode) — assim hover e destaques
// seguem o branding, não só o `bg-primary` base. Fora de um espaço de org (ou
// org sem cor), volta ao verde ETUS. Não renderiza nada.

// Defaults = os mesmos hex do index.css (não mudam nada no tema padrão).
const ETUS_GREEN = { base: "6 110 62", dark: "5 82 50", light: "10 143 82" };

function hexToRgb(hex: string): number[] | null {
  const m = /^#([0-9a-fA-F]{6})$/.exec(hex);
  if (!m) return null;
  const n = Number.parseInt(m[1], 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

const triplet = (rgb: number[]) =>
  rgb.map((c) => Math.max(0, Math.min(255, Math.round(c)))).join(" ");
const darken = (rgb: number[]) => rgb.map((c) => c * 0.78); // ~22% mais escuro
const lighten = (rgb: number[]) => rgb.map((c) => c + (255 - c) * 0.45); // mistura c/ branco

export function OrgThemeBridge() {
  const { activeSpace } = useActiveSpace();
  const spaces = useSpaces();

  const org =
    activeSpace.type === "org" ? spaces.data?.orgs.find((o) => o.id === activeSpace.id) : undefined;
  const color = org?.primaryColor ?? null;

  useEffect(() => {
    const root = document.documentElement.style;
    const rgb = color ? hexToRgb(color) : null;
    const set = (base: string, dark: string, light: string) => {
      root.setProperty("--color-primary", base);
      root.setProperty("--color-primary-dark", dark);
      root.setProperty("--color-primary-light", light);
    };
    if (rgb) {
      set(triplet(rgb), triplet(darken(rgb)), triplet(lighten(rgb)));
    } else {
      set(ETUS_GREEN.base, ETUS_GREEN.dark, ETUS_GREEN.light);
    }
    return () => set(ETUS_GREEN.base, ETUS_GREEN.dark, ETUS_GREEN.light);
  }, [color]);

  return null;
}
